import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import classNames from 'classnames'

import MyListButton from '../../../shared/my-list/my-list-button'
import styles from './overlay-with-my-list-button.css'

import TILE_FRAGMENT from '../../../../../graphql/fragments/tile.gql'
import { COMPONENT_NAME_CAROUSEL } from '../../../../lib/analytics/custom-dimensions'

export function OverlayWithMyListButton({
  tile,
  isOnMyList,
  isAuthenticated,
  addToMyList,
  renderedInComponent
}) {
  const contentItem = tile.contentItem
  const isRental = contentItem.isRental

  return (
    <div className={classNames(styles.wrapper, {
      [styles.wrapperNeonRental]: isRental
    })}
    >
      {isAuthenticated && (
        <MyListButton
          contentItem={contentItem}
          className={styles.addMyListButton}
          isOnMyList={isOnMyList}
          addAction={addToMyList(renderedInComponent)}
          isRental={isRental}
        />
      )}
    </div>
  )
}

OverlayWithMyListButton.propTypes = {
  tile: propType(TILE_FRAGMENT).isRequired,
  isOnMyList: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  addToMyList: PropTypes.func.isRequired,
  renderedInComponent: PropTypes.string
}

OverlayWithMyListButton.defaultProps = {
  isOnMyList: false,
  isAuthenticated: false,
  renderedInComponent: COMPONENT_NAME_CAROUSEL
}
